"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var EffectManager =
/** @class */
function () {
  function EffectManager(_a) {
    var _b = (_a === void 0 ? {} : _a).include,
        include = _b === void 0 ? true : _b;
    this.effects = [];
    this.kinds = new Set();
    this.include = include;
  }

  Object.defineProperty(EffectManager.prototype, "finished", {
    get: function get() {
      return this.effects.length === 0;
    },
    enumerable: true,
    configurable: true
  });

  EffectManager.prototype.reset = function () {
    this.effects = [];
    this.kinds = new Set();
  };

  EffectManager.prototype.add = function (effect, kind) {
    if (kind != null) {
      this.kinds.add(kind);
    }

    if (effect == null || typeof effect !== 'object' || !('then' in effect)) {
      return;
    }

    this.effects.push(effect);
  };

  EffectManager.prototype.resolve = function () {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , Promise.all(this.effects)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  EffectManager.prototype.betweenEachPass = function (pass) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , Promise.all(tslib_1.__spread(this.kinds).map(function (kind) {
              return typeof kind.betweenEachPass === 'function' ? kind.betweenEachPass(pass) : Promise.resolve();
            }))];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  EffectManager.prototype.afterEachPass = function (pass) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var results;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , Promise.all(tslib_1.__spread(this.kinds).map(function (kind) {
              return typeof kind.afterEachPass === 'function' ? kind.afterEachPass(pass) : Promise.resolve();
            }))];

          case 1:
            results = _a.sent();
            return [2
            /*return*/
            , results.every(function (result) {
              return result !== false;
            })];
        }
      });
    });
  };

  EffectManager.prototype.shouldPerform = function (kind) {
    var include = this.include;

    if (!include) {
      return false;
    }

    return include === true || kind != null && include.includes(kind.id);
  };

  return EffectManager;
}();

exports.EffectManager = EffectManager;